export const QUOTE_SETTINGS = {
  currencySymbol: '$',
  currencyLabel: 'AUD',
  basePriceMatrix: [
    { widthMin: 300, widthMax: 900, depthMin: 300, depthMax: 900, price: 575 },
    { widthMin: 901, widthMax: 1200, depthMin: 300, depthMax: 900, price: 675 },
    { widthMin: 300, widthMax: 900, depthMin: 901, depthMax: 1200, price: 675 },
    { widthMin: 901, widthMax: 1200, depthMin: 901, depthMax: 1200, price: 800 },
    { widthMin: 1201, widthMax: 1500, depthMin: 300, depthMax: 900, price: 820 },
    { widthMin: 300, widthMax: 900, depthMin: 1201, depthMax: 1500, price: 820 },
    { widthMin: 1201, widthMax: 1500, depthMin: 901, depthMax: 1200, price: 977 },
    { widthMin: 901, widthMax: 1200, depthMin: 1201, depthMax: 1500, price: 977 },
    { widthMin: 1501, widthMax: 1800, depthMin: 300, depthMax: 900, price: 1200 },
    { widthMin: 300, widthMax: 900, depthMin: 1501, depthMax: 1800, price: 1200 },
    { widthMin: 1501, widthMax: 1800, depthMin: 901, depthMax: 1200, price: 1300 },
    { widthMin: 901, widthMax: 1200, depthMin: 1501, depthMax: 1800, price: 1300 },
  ],
  screenCutoffFee: 40,
  deliveryFee: 55,
  gstRate: 0.1,
  leadTimes: {
    manufacturing: '5 business days',
    shipping: '2-5 business days',
  },
  p3SlipRating: 'P3 Slip Rating',
  disclaimer: 'Quotes are valid for 30 days from the date of issue.',
}
